// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Subhero_Hero__11JuX","heroImage":"Subhero_heroImage__22cAB","btn":"Subhero_btn__2Qkmi","title":"Subhero_title__29ypA","lead":"Subhero_lead__237Xt"};